import React from 'react';

type LabelValuePairProps = {
  label: string;
  value: string | number;
};

const LabelValuePair: React.FC<LabelValuePairProps> = ({ label, value }) => {
  return (
    <div className="flex flex-row gap-1">
      <span className="text-xs font-bold">
        {label}:
      </span>
      <span className="text-xs">
        {value}
      </span>
    </div>
  );
};

export default LabelValuePair;
